import { makeSupabaseClient } from '@/shared/infra/supabase'

export type UploadToSignedUrlParams = {
  bucket: string
  path: string
  token: string
  file: Blob
  signal?: AbortSignal
}

export type UploadToSignedUrl = (params: UploadToSignedUrlParams) => Promise<void>

export const uploadToSignedUrl: UploadToSignedUrl = async ({
  bucket,
  path,
  token,
  file,
  signal,
}) => {
  if (signal?.aborted) {
    throw new DOMException('Upload aborted', 'AbortError')
  }

  const supabase = makeSupabaseClient()
  const uploadPromise = supabase.storage
    .from(bucket)
    .uploadToSignedUrl(path, token, file)

  const result = signal
    ? await Promise.race([uploadPromise, rejectOnAbort(signal)])
    : await uploadPromise

  if (result.error) {
    throw new Error(result.error.message)
  }
}

function rejectOnAbort(signal: AbortSignal): Promise<never> {
  return new Promise<never>((_, reject) => {
    signal.addEventListener(
      'abort',
      () => reject(new DOMException('Upload aborted', 'AbortError')),
      { once: true },
    )
  })
}
